import React, { Component } from "react";
import axios from "axios";
import "./styles/BS5-V3.min.css";
import "./styles/BS5-Global-Custom-2023.css";
import { v4 } from "uuid";

import '@iframe-resizer/child'
import "react-datepicker/dist/react-datepicker.css";
import { RegistrationForm } from "./Components/registration-form/RegistrationForm";

let countriesWithPostalCodes = [
  "Algeria",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Azores",
  "Bangladesh",
  "Belarus",
  "Belgium",
  "Bosnia",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Canada",
  "Canary Islands",
  "China, People’s Republic of",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "England",
  "Estonia",
  "Faeroe Islands",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Greece",
  "Greenland",
  "Guam",
  "Guernsey",
  "Holland",
  "Hungary",
  "India",
  "Indonesia",
  "Israel",
  "Italy",
  "Japan",
  "Jersey",
  "Kazakhstan",
  "Korea, South",
  "Kosrae",
  "Kyrgyzstan",
  "Latvia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia (FYROM)",
  "Madagascar",
  "Madeira",
  "Malaysia",
  "Marshall Islands",
  "Martinique",
  "Mayotte",
  "Mexico",
  "Mongolia",
  "Montenegro",
  "Netherlands",
  "New Zealand",
  "Northern Ireland",
  "Norway",
  "Pakistan",
  "Philippines",
  "Poland",
  "Ponape",
  "Portugal",
  "Puerto Rico",
  "Reunion",
  "Russia",
  "Saudi Arabia",
  "Scotland",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "St. Barthelemy",
  "St. Croix",
  "St. John",
  "St. Thomas",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tajikistan",
  "Thailand",
  "Truk",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "U.S. Virgin Islands",
  "Ukraine",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vatican City State",
  "Vietnam",
  "Wales",
  "Yap",
];
let states = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];
let products = [
  "VidiU Pro",
  "VidiU Mini",
  "VidiU Go Node",
  "VidiU Go",
  "VidiU (original)",
  "Teradek RT / RT Motion",
  "T-RAX",
  "Sphere",
  "StreamReader for Wirecast",
  "StreamReader for TriCaster",
  "Slice (1st Gen)",
  "Slice 656/676",
  "Slice 756/776",
  "Serv Pro",
  "Preconfigured Sputnik Server (Desktop / Rack Mount)",
  "Node",
  "Link Pro",
  "Link",
  "Cube x05/x06/x55 (2nd gen)",
  "Cube x00/x20/x50 (1st gen)",
  "Cube 605/655 (3rd gen)",
  "Cube 705/755 (4th Gen with HEVC)",
  "COLR Duo",
  "COLR",
  "Clip",
  "Bond Backpack",
  "Bond Expansion Module",
  "Bond Pro",
  "Bond II",
  "Bond (original)",
  "Bolt Standard / Bolt Pro (1st gen)",
  "Bolt Sidekick II (2nd gen)",
  "Bolt Sidekick (1st gen)",
  "Bolt 300 (2nd gen)",
  "Bolt 500 (3rd gen)",
  "Bolt 600 (2nd gen)",
  "Bolt 1000 (3rd gen)",
  "Bolt 2000 (1st or 2nd gen)",
  "Bolt 3000 (3rd gen)",
  "Bolt 10K",
  "Bolt Sidekick LT",
  "Bolt 500 LT",
  "Bolt 1000 LT",
  "Bolt Sidekick XT",
  "Bolt 500 XT",
  "Bolt 1000 XT",
  "Bolt 3000 XT",
  "Bolt 4K",
  "Beam",
  "Base",
  "Ace 500",
  "Ace 800",
  "Prism",
  "Spark",
  "Wave",
];
products = products.sort((a, b) => a.localeCompare(b));

let startingInputs = [
  {
    id: "firstName",
    label: "First Name",
    inputType: "one-line",
    sublabel: null,
    errorMessage: null,
  },
  {
    id: "lastName",
    label: "Last Name",
    inputType: "one-line",
    sublabel: null,
    errorMessage: null,
  },
  {
    id: "company",
    label: "Company (optional)",
    inputType: "one-line",
    sublabel: null,
    errorMessage: null,
  },
  {
    id: "email",
    label: "E-mail",
    inputType: "one-line",
    sublabel: null,
    errorMessage: null,
  },
  {
    id: "serials",
    label: "Serial Number of your Teradek Product(s):",
    sublabel:
      "Most serial numbers are 8-10 digits long and do not include the revision letter. Enter each serial number separately.",
    values: products,
    entries: [],
    inputType: "dropdown-with-text",
    errorMessage: null,
  },
];

class App extends Component {
  constructor(props) {
    super(props);
    this.scrollDiv = React.createRef();
    this.state = {
      appRegistration: false,
      selectedTeradekIDLogin: false,
      showCoreLogin: false,
      loggedInToCore: false,
      bypassAddress: false,
      isLoading: false,
      formError: null,
      interests: false,
      country: "United States",
      finished: false,
      zipMatch: true,
      limboLine1Address: "testing",
      limboLine2Address: "testing",
      limboCity: "testing",
      limboState: "testing",
      limboCountry: "testing",
      limboPostalCode: "12345",
      termsandcondition: false,
      termsandconditionerror: false,
      inputs: startingInputs,
      privacyOpen: false,
      warrantyOpen: false,
      hasSerialError: false,
      hideForm: false,
    };
    this.sendForm = this.sendForm.bind(this);
    this.validateAddress = this.validateAddress.bind(this);
    this.handleForm = this.handleForm.bind(this);
    this.resetErrors = this.resetErrors.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAddressErrors = this.handleAddressErrors.bind(this);
    this.handleError = this.handleError.bind(this);
    this.clearErrorById = this.clearErrorById.bind(this);
  }

  clearAllErrors = () => {
    let inputs = this.state.inputs.slice();
    inputs.forEach((each) => (each.errorMessage = null));
    this.setState({ inputs });
  };

  selectCoreAddress = (addressIndex) => {
    let teradekIDLogin = { ...this.state.teradekIDLogin };
    let address = teradekIDLogin.addresses[addressIndex];
    this.setState({
      company: address.name,
      line1Address: address.line1Address,
      line2Address: address.line2Address,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      country: address.country,
      selectedTeradekIDLogin: true,
    });
  };

  toggleLogin = () => {
    this.setState({ showCoreLogin: !this.state.showCoreLogin });
  };

  toggleAddresses = () => {
    this.setState({
      selectedTeradekIDLogin: !this.state.selectedTeradekIDLogin,
    });
  };

  handleCoreLogin = (email, secret) => {
    this.setState({ teradekIDLogin: null });
    let query = `query {
      teradekIDLogin(email: "${email}", password: "${secret}") {
        id
        firstName
        lastName
        email
        phone
        addresses {
          name
          line1Address
          line2Address
          city
          state
          postalCode
          country
        }
        error
      }
    }
    `;

    axios({
      method: "post",
      url: "http://localhost:3576/graphql",
      data: {
        query,
      },
    })
      .then((res) => {
        console.log(res.data.data);
        let teradekIDLogin = res.data.data.teradekIDLogin;
        if (teradekIDLogin.error !== null) {
          this.setState({ coreLoginError: teradekIDLogin.error });
          return;
        }
        this.setState({
          teradekIDLogin,
          loggedInToCore: true,
          teradekID: teradekIDLogin.id,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getQueryString = () => {
    var qs = (function (a) {
      if (a == "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i) {
        var p = a[i].split("=", 2);
        if (p.length == 1) b[p[0]] = "";
        else if (!b[p[0]]) {
          b[p[0]] = [];
          b[p[0]].push(decodeURIComponent(p[1].replace(/\+/g, " ")));
        } else {
          b[p[0]].push(decodeURIComponent(p[1].replace(/\+/g, " ")));
        }
      }
      return b;
    })(window.location.search.substr(1).split("&"));
    return qs;
  };

  is_numeric = (str) => {
    return /^\d+$/.test(str);
  };

  componentDidMount = () => {
    let qs = this.getQueryString();
    let serials = qs.serials;

    let inputs = this.state.inputs.slice();
    console.log("inputs", inputs);
    let inputIndex = inputs.findIndex((each) => each.id === "serials");
    // let lastEntry = inputs[inputIndex].entries[index].product
    if (serials && serials.length && serials[0].split(",").length) {
      this.setState({ appRegistration: true });
      serials[0].split(",").forEach((serial) => {
        let trimmedSerial = serial.trim();
        let newSerial = this.is_numeric(trimmedSerial[trimmedSerial.length - 1])
          ? trimmedSerial
          : trimmedSerial.slice(0, -1);
        inputs[inputIndex].entries.push({
          id: v4(),
          value: newSerial.trim(),
          submitted: false,
        });
      });
    } else {
      this.setState({ appRegistration: false });
      inputs[inputIndex].entries.push({
        id: v4(),
        value: "",
        submitted: false,
      });
    }
    this.setState({ inputs });
  };

  scrollElementIntoView = (element) => {
    let scrollTop = window.pageYOffset || element?.scrollTop || 20;
    const finalOffset = element?.getBoundingClientRect()?.top + scrollTop - 20;
    window.parent.postMessage(finalOffset, "*");
  };

  goToFirstError = () => {
    let input = this.state.inputs.find((each) => !!each.errorMessage);
    if (input) {
      this.scrollElementIntoView(document.getElementById(input.id));
    }
  };

  removeSerial = (index) => {
    let inputs = this.state.inputs.slice();
    let inputIndex = inputs.findIndex((each) => each.id === "serials");
    inputs[inputIndex].entries = inputs[inputIndex].entries.filter(
      (each, eachIndex) => eachIndex !== index
    );
    this.setState({ inputs });
  };

  addAnotherSerial = (index) => {
    let inputs = this.state.inputs.slice();
    let inputIndex = inputs.findIndex((each) => each.id === "serials");
    inputs[inputIndex].entries.push({ id: v4(), value: "", submitted: false });
    this.setState({ inputs });
  };

  changeSerialByIndex = (input, entryIndex, value) => {
    console.log("this.state.appRegistration", this.state.appRegistration);
    console.log("this.state.hasSerialError", this.state.hasSerialError);
    if (this.state.appRegistration && !this.state.hasSerialError) {
      return;
    }
    let inputs = this.state.inputs;
    let inputIndex = inputs.findIndex((each) => each.id === input.id);
    inputs[inputIndex].errorMessage = null;
    inputs[inputIndex].entries[entryIndex].value = value;
    inputs[inputIndex].entries[entryIndex].errorMessage = null;
    this.setState({ inputs });
  };

  openModal = () => {
    this.setState({ finished: true });
  };

  closeModal = () => {
    window.location.reload();
  };

  handleError = (id, errorMessage) => {
    if (id === "form") {
      this.setState({ formError: errorMessage });
    } else {
      let inputs = this.state.inputs.slice();
      let inputId = inputs.findIndex((each) => each.id === id);
      inputs[inputId].errorMessage = errorMessage;
      this.setState({ inputs });
    }
  };

  handleSerialError = (serial, message) => {
    let inputs = this.state.inputs.slice();
    let serials = inputs.find((each) => each.id === "serials");
    let entry = serials.entries.find((each) => each.value === serial);
    entry.errorMessage = message;
    this.setState({ inputs });
  };

  handleInterests = (e) => {
    this.setState({ interests: !this.state.interests });
  };

  clearErrorById = (id) => {
    let inputs = this.state.inputs.slice();
    let inputIndex = inputs.findIndex((each) => each.id === id);
    if (inputs[inputIndex]) {
      inputs[inputIndex].errorMessage = null;
      this.setState({ inputs });
    }
  };

  handleChange = (id, value) => {
    if (this.state.isLoading) return;
    this.setState({ [id]: value });
    this.clearErrorById(id);
  };

  handleMultiDropdownChange = (entryId, value) => {
    if (this.state.isLoading) return;
    let inputs = this.state.inputs;
    let inputIndex = inputs.findIndex((each) => each.id === "serials");
    let entryIndex = inputs[inputIndex].entries.findIndex(
      (each) => each.id === entryId
    );
    inputs[inputIndex].entries[entryIndex].product = value;
    this.setState({ inputs });
  };

  resetErrors = () => {
    let inputs = this.state.inputs.slice();
    inputs.forEach((input) => {
      input.errorMessage = null;
    });
    this.setState({ inputs, formError: null });
  };

  resetForm = () => {
    window.location.reload();
  };

  updateQueryStringParameter = (uri, key, value) => {
    console.log("uri, key, value", uri, key, value);
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      return uri + separator + key + "=" + value;
    }
  };

  sendForm = (formData) => {
    let query = `mutation ($input: CntctInput!) {
      addContactToXtupleFromForm (input:$input) {
        error
        errors {
          errorId
          message
          serial
        }
      }
    }`;
    axios({
      method: "post",
      url: "/graphql",
      data: {
        query,
        variables: {
          input: {
            firstName: formData.firstName ? formData.firstName.trim() : null,
            lastName: formData.lastName ? formData.lastName.trim() : null,
            name: formData.company ? formData.company.trim() : null,
            email: formData.email ? formData.email.trim() : null,
            phone: formData.phone ? formData.phone.trim() : null,
            line1Address: formData.line1Address
              ? formData.line1Address.trim()
              : null,
            line2Address: formData.line2Address
              ? formData.line2Address.trim()
              : null,
            city: formData.city ? formData.city.trim() : null,
            state: formData.state ? formData.state.trim() : null,
            postalCode: formData.postalCode ? formData.postalCode.trim() : null,
            country: formData.country ? formData.country.trim() : null,
            serials: formData.serials,
            purchasedAt: formData.purchasedAt
              ? formData.purchasedAt.trim()
              : null,
            purchasedAtReseller: formData.purchasedAtReseller
              ? formData.purchasedAtReseller.trim()
              : null,
            dateOfPurchase: formData.dateOfPurchase
              ? formData.dateOfPurchase.trim()
              : null,
            orderNumber: formData.orderNumber
              ? formData.orderNumber.trim()
              : null,
            product: formData.product ? formData.product.trim() : null,
            category: formData.category ? formData.category.trim() : null,
            companySize: formData.companySize
              ? formData.companySize.trim()
              : null,
            referral: formData.referral ? formData.referral.trim() : null,
            referralNote: formData.referralNote
              ? formData.referralNote.trim()
              : null,
            subscriptions: formData.subscriptions
              ? formData.subscriptions
              : null,
          },
        },
      },
    })
      .then((res) => {
        this.setState({ isLoading: false });
        let addContactToXtupleFromForm = res.data.data.addContactToXtupleFromForm;
        let erroredSerials = addContactToXtupleFromForm.errors.map((each) => each.serial);
        if (addContactToXtupleFromForm.error === true) {
          let inputs = this.state.inputs.slice();
          let serials = inputs.find((each) => each.id === "serials");
          serials.entries.forEach((each) => {
            if (erroredSerials.includes(each.value)) {
              this.setState({ hasSerialError: true });
              this.handleSerialError(
                each.value,
                "Serial number does not match our records"
              );
            }
          });
          if (erroredSerials.length > 0) {
            this.scrollElementIntoView(this.scrollDiv.current);
          }
          this.setState({ xtupleResponse: true, inputs });
        } else {
          this.setState({ hideForm: true });
          this.clearAllErrors();
          let newUrl = this.updateQueryStringParameter(
            window.location.href,
            "finished",
            "true"
          );
          window.history.pushState(null, null, newUrl);
          this.setState({ xtupleResponse: true, finished: true }, () => {
            if (this.state.appRegistration) {
              this.goToThanks();
            } else {
              this.scrollElementIntoView(document.getElementById("thank-you"));
            }
          });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        alert(
          "We are currently having trouble with our registration form, please try again at another time."
        );
      });
  };

  validateAddress = (formData) => {
    let query = `query ($input: AddressValidationInput!) {
      validateAddress (input:$input) {
        resolved
        failed
        line1Address
        line2Address
        city
        state
        postalCode
        country
        attributes {
          name
          value
        }
        errors
      } 
    }`;
    axios({
      method: "post",
      url: "/graphql",
      data: {
        query,
        variables: {
          input: {
            line1Address: formData.line1Address,
            line2Address: formData.line2Address,
            city: formData.city,
            state: formData.state,
            postalCode: formData.postalCode,
            country: formData.country,
          },
        },
      },
    })
      .then((res) => {
        this.setState({ isLoading: false });
        let validateAddress = res.data.data.validateAddress;
        if (validateAddress.failed === true) {
          this.handleAddressErrors(validateAddress);
          console.log("Failed to normalize address");
        } else {
          if (validateAddress.resolved === true) {
            if (
              validateAddress.postalCode === this.state.postalCode ||
              validateAddress.postalCode.substring(0, 5) ===
                this.state.postalCode
            ) {
              this.handleAddressErrors(validateAddress);
              this.sendForm(formData);
            } else {
              this.setState(
                {
                  zipMatch: false,
                  limboLine1Address: validateAddress.line1Address,
                  limboLine2Address: validateAddress.line2Address,
                  limboCity: validateAddress.city,
                  limboState: validateAddress.state,
                  limboPostalCode: validateAddress.postalCode,
                },
                () => {
                  this.scrollElementIntoView(
                    document.getElementById("confirm-address")
                  );
                }
              );
            }
          } else if (validateAddress.resolved === false) {
            console.log("Address NOT Resolved");
            this.handleAddressErrors(validateAddress);
          }
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  };

  handleAddressErrors = (validateAddress) => {
    if (validateAddress.attributes && validateAddress.attributes.length > 0) {
      validateAddress.attributes.forEach((attribute) => {
        if (
          attribute.name === "CountrySupported" &&
          attribute.value === "false"
        ) {
          this.handleError("country", "Country not supported");
        } else if (
          attribute.name === "PostalValidated" &&
          attribute.value === "false"
        ) {
          this.handleError("postalCode", "Invalid Postal Code");
        } else if (
          attribute.name === "CityStateValidated" &&
          attribute.value === "false"
        ) {
          this.handleError("city", "Invalid city/state");
          if (this.state.country === "United States") {
            if (states.indexOf(this.state.state) === -1) {
              this.handleError("state", "Invalid city/state");
            }
          } else {
            this.handleError("state", "Invalid state");
          }
        } else if (
          attribute.name === "StreetValidated" &&
          attribute.value === "false"
        ) {
          this.handleError("line1Address", "Invalid street address");
          if (!!this.state.line2Address) {
            this.handleError("line2Address", "Invalid street address");
          }
        }
      });
      this.goToFirstError();
    }
  };

  validateEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  handleValidation = (type, value) => {
    return new Promise((resolve, reject) => {
      switch (type) {
        case "firstName":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "lastName":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "company":
          resolve("Good");
          break;
        case "line1Address":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "line2Address":
          resolve("Good");
          break;
        case "city":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "state":
          resolve("Good");
          break;
        case "postalCode":
          if (
            countriesWithPostalCodes.indexOf(this.state.country) !== -1 &&
            !value
          ) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "country":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "email":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          var validEmailRegex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          let isValidEmail = validEmailRegex.test(
            String(value).toLowerCase().trim()
          );
          if (!isValidEmail) {
            this.handleError(type, "Invalid Email");
            reject("Bad");
          } else {
            resolve("Good");
          }
          break;
        case "phone":
          resolve("Good");
          break;
        case "orderNumber":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "serials":
          if (value.entries.some((each) => each.value === "")) {
            this.handleError(type, "Serial or product information missing");
            reject("Serial or product information missing");
            break;
          }
          resolve("Good");
          break;
        case "purchasedAt":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "purchasedAtReseller":
          if (this.state.purchasedAt === "A Reseller" && !value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "dateOfPurchase":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          } else if (value > new Date()) {
            this.handleError(type, "Invalid Date");
            reject("Invalid Date");
            break;
          }
          resolve("Good");
          break;
        case "category":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "companySize":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "referral":
          if (!value) {
            this.handleError(type, "Empty field");
            reject("Empty field");
            break;
          }
          resolve("Good");
          break;
        case "referralNote":
          resolve("Good");
          break;
        default:
          resolve("Good");
          break;
      }
    });
  };

  handleForm = () => {
    if (this.state.isLoading || this.state.finished) return;
    this.setState({ isLoading: true });
    this.resetErrors();

    Promise.all([
      this.handleValidation("firstName", this.state.firstName),
      this.handleValidation("lastName", this.state.lastName),
      this.handleValidation("company", this.state.company),
      this.handleValidation("email", this.state.email),
      this.handleValidation(
        "serials",
        this.state.inputs.find((each) => each.id === "serials")
      ),
    ])
      .then((values) => {
        if (!this.state.termsandcondition) {
          this.setState({ termsandconditionerror: true });
          this.setState({ isLoading: false });

          return;
        } else {
          this.setState({ termsandconditionerror: false });
        }

        let formData = this.getFormData();

        this.sendForm(formData);
      })
      .catch((err) => {
        this.goToFirstError();
        this.setState({ isLoading: false });
      });
  };

  setUpgradeCode = (value) => {
    this.setState({ upgradecode: value });
  };

  getFormData = () => {
    let firstName = this.state.firstName || null;
    let lastName = this.state.lastName || null;
    let company = this.state.company || null;
    let line1Address = this.state.line1Address || null;
    let line2Address = this.state.line2Address || "";
    let city = this.state.city || null;
    let state = this.state.state || null;
    let postalCode = this.state.postalCode || null;
    let country = this.state.country || null;
    let email = this.state.email || null;
    let phone = this.state.phone || null;
    let orderNumber = this.state.orderNumber || null;
    let serialsInput = this.state.inputs.find((each) => each.id === "serials");
    let serials = serialsInput ? serialsInput.entries : null;
    let product = this.state.product || null;
    let purchasedAt = this.state.purchasedAt || null;
    let purchasedAtReseller = this.state.purchasedAtReseller || null;
    let dateOfPurchase = this.state.dateOfPurchase || null;
    let category = this.state.category || null;
    let companySize = this.state.companySize || null;
    let referral = this.state.referral || null;
    let referralNote = this.state.referralNote || null;
    let subscriptions = this.state.interests || false;

    let formData = {
      firstName,
      lastName,
      company,
      line1Address,
      line2Address,
      city,
      state,
      postalCode,
      country,
      email,
      phone,
      orderNumber,
      serials,
      product,
      purchasedAt,
      purchasedAtReseller,
      dateOfPurchase,
      category,
      companySize,
      referral,
      referralNote,
      subscriptions,
    };
    return formData;
  };

  confirmAddress = (which) => {
    this.setState({ zipMatch: true });
    if (which === "submitted") {
      let formData = this.getFormData();
      this.sendForm(formData);
    } else if (which === "validated") {
      this.setState(
        {
          line1Address: this.state.limboLine1Address,
          line2Address: this.state.limboLine2Address,
          city: this.state.limboCity,
          state: this.state.limboState,
          country: this.state.limboCountry,
          postalCode: this.state.limboPostalCode,
        },
        () => {
          let formData = this.getFormData();
          this.sendForm(formData);
        }
      );
    }
  };

  goToWarranty = () => {
    this.setState({ warrantyOpen: true });
    setTimeout(() => {
      document.getElementById("warranty").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    }, 100);
  };

  goToPrivacy = () => {
    this.setState({ privacyOpen: true });
    setTimeout(() => {
      document.getElementById("warranty").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    }, 100);
  };

  goToThanks = () => {
    setTimeout(() => {
      document.getElementById("thank-you").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    }, 100);
  };

  jump = (h) => {
    console.log("h", h);
    var url = window.location.href; //Save down the URL without hash.
    window.location.href = "#" + h; //Go to the target element.
    window.history.replaceState(null, null, url); //Don't like hashes. Changing it back.
  };

  render() {
    return (
      <RegistrationForm
        hideForm={this.state.hideForm}
        onSubmit={this.handleForm}
        inputs={this.state.inputs}
        interests={this.state.interests}
        handleInterests={this.handleInterests}
        isLoading={this.state.isLoading}
        formError={this.props.formError}
        finished={this.state.finished}
        handleChange={this.handleChange}
        state={this.state}
        changeSerialByIndex={this.changeSerialByIndex}
        addAnotherSerial={this.addAnotherSerial}
        appRegistration={this.state.appRegistration}
        scrollDiv={this.scrollDiv}
        removeSerial={this.removeSerial}
        xtupleResponse={this.state.xtupleResponse}
      />
    );
  }
}

export default App;
